import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';


function Input(props){
    const[imgval,setimgval]=useState("");
    let navigate=useNavigate();
    return(
        <>
            <div className='searchinput'>
            <input type='text' placeholder='search'
             value={imgval}
             onChange={(val)=>setimgval(val.target.value)}
             onKeyPress={(e)=>{if(e.charCode===13) {
                navigate('/search',{state:imgval})
              }}}
              className={props.inputname}
             />
            <SearchIcon style={{ fontSize:`${props.fontsearch}`,color: '#ddc4c4'}}
            onClick={()=>navigate('/search',{state:imgval})}/>
            </div>
        </>
    )
}
export  default Input;